import { tv, type VariantProps } from "@ui/lib/tv";

/**
 * A plain square checkbox + label — the /programs "Instruction language" grid.
 * Distinct from `system/CheckboxGroup`, which renders Tile-styled bordered rows
 * with a circular indicator. Here the indicator is the design's 20px rounded-4px
 * square that fills red-400 with a white tick when selected.
 */
export const checkbox = tv({
  slots: {
    root: "group/cb flex cursor-pointer items-center gap-3 outline-none data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50",
    box: "flex size-5 shrink-0 items-center justify-center rounded-[4px] border border-neutral-200 bg-white text-white transition-colors",
    label: "text-base leading-6 text-neutral-900",
  },
  variants: {
    isHovered: { true: {} },
    isSelected: { true: { box: "border-red-400 bg-red-400" } },
    isFocusVisible: { true: { box: "outline-2 outline-offset-2 outline-red-300" } },
  },
  compoundVariants: [{ isSelected: false, isHovered: true, class: { box: "border-neutral-300" } }],
});

export type CheckboxVariants = VariantProps<typeof checkbox>;
